export const filters = [
    { id: 2, name: "Jas", value: "jas" },
    { id: 3, name: "Rock", value: "rock" },
    { id: 4, name: "Melody", value: "melody" },
    { id: 5, name: "Karoke", value: "karoke" },
  ];
  
  export const filterByLanguage = [
    
    { id: 1, name: "English", value: "english" },
    { id: 2, name: "Hindi", value: "hindi" },
    { id: 3, name: "Gujarati", value: "gujarati" },
    { id: 4, name: "Telugu", value: "telugu" },
  ];

  